import { React } from '../utils/thirdpartyComponents';
import CWSwitch from './CWSwitch';
import './LocationFeatureToggles.scss';

interface LocationFeatureTogglesProps {
  allowGiftCardManagement: boolean;
  blockDiscountedGiftCards: boolean;
  allowLoyaltyPointsManagement: boolean;
  onGiftCardChange: (enabled: boolean) => void;
  onBlockDiscountedGiftCardsChange: (enabled: boolean) => void;
  onLoyaltyChange: (enabled: boolean) => void;
}

const LocationFeatureToggles: React.FC<LocationFeatureTogglesProps> = ({
  allowGiftCardManagement,
  blockDiscountedGiftCards,
  allowLoyaltyPointsManagement,
  onGiftCardChange,
  onBlockDiscountedGiftCardsChange,
  onLoyaltyChange,
}) => (
  <>
    <div className="car-info-sec d-flex flex-column align-items-start mb-4">
      <div className="info-switch d-flex align-items-center gap-3">
        <h5 className="f-bold m-0">Allow Gift Card Management</h5>
        <CWSwitch
          id="allowGiftCardManagement"
          name="allowGiftCardManagement"
          checked={allowGiftCardManagement}
          onChange={() => onGiftCardChange(!allowGiftCardManagement)}
        />
      </div>
    </div>
    <div className="car-info-sec location-feature-toggle d-flex flex-column align-items-start mb-4">
      <div className="info-switch d-flex align-items-center gap-3">
        <h5 className="f-bold m-0">Block discounted Gift Cards from being used to buy a discounted wash.</h5>
        <CWSwitch
          id="blockDiscountedGiftCards"
          name="blockDiscountedGiftCards"
          checked={blockDiscountedGiftCards}
          onChange={() => onBlockDiscountedGiftCardsChange(!blockDiscountedGiftCards)}
        />
      </div>
      <p className="toggle-subtext">
        On enabling this, users won&apos;t be able to use the Gift cards which are bought on discount, for purchasing a wash which already has a discount.
      </p>
    </div>
    <div className="car-info-sec d-flex flex-column align-items-start mb-4">
      <div className="info-switch d-flex align-items-center gap-3">
        <h5 className="f-bold m-0">Allow Loyalty Points Management</h5>
        <CWSwitch
          id="allowLoyaltyPointsManagement"
          name="allowLoyaltyPointsManagement"
          checked={allowLoyaltyPointsManagement}
          onChange={() => onLoyaltyChange(!allowLoyaltyPointsManagement)}
        />
      </div>
    </div>
  </>
);

export default LocationFeatureToggles;
